import { ApplicationConfig, importProvidersFrom, provideAppInitializer, inject } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { ConfigService } from './configService';
import { GoogleAnalyticsService } from './services/analytics/google-analytics.service';

class EmptyLoader implements TranslateLoader {
  getTranslation(): Observable<any> { return of({}); }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideRouter([]),
    importProvidersFrom(TranslateModule.forRoot({
      loader: { provide: TranslateLoader, useClass: EmptyLoader }
    })),
    provideAppInitializer(() => inject(ConfigService).load()),
    GoogleAnalyticsService
  ]
};

